const Stakepile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 560 560">
    <path
      style={{
        fill: "#fff",
      }}
      d="M0 0h560v560H0z"
    />
    <path
      style={{
        fill: "none",
        stroke: "#f5980c",
        strokeWidth: 9,
      }}
      d="M27.5 388.3v33.03M467.93 388.3v33.03"
    />
    <ellipse
      cx={247.8}
      cy={421.33}
      rx={224.8}
      ry={64.23}
      style={{
        fill: "#f5980c",
      }}
    />
    <path
      d="M465.11 386.47c0 5.06-3.66 11.55-14.37 18.78-10.45 7.06-26.07 13.72-46 19.42-39.84 11.38-95.31 18.53-156.9 18.53s-117.06-7.15-156.9-18.53c-20-5.7-35.58-12.36-46-19.42C34.15 398 30.5 391.53 30.5 386.47s3.65-11.55 14.36-18.79c10.46-7.06 26.07-13.71 46-19.42 39.84-11.38 95.32-18.52 156.9-18.52s117.06 7.14 156.9 18.52c20 5.71 35.59 12.36 46 19.42 10.79 7.24 14.45 13.72 14.45 18.79Z"
      style={{
        fill: "#f2c94c",
        stroke: "#f5980c",
        strokeWidth: 15,
      }}
    />
    <path
      style={{
        fill: "none",
        stroke: "#f5980c",
        strokeWidth: 9,
      }}
      d="M89.89 307.56v33.03M530.32 307.56v33.03"
    />
    <ellipse
      cx={310.2}
      cy={340.59}
      rx={224.8}
      ry={64.23}
      style={{
        fill: "#f5980c",
      }}
    />
    <path
      d="M527.5 305.72c0 5.06-3.65 11.55-14.36 18.79-10.46 7.06-26.07 13.71-46 19.42-39.84 11.38-95.32 18.52-156.9 18.52s-117.06-7.14-156.9-18.52c-20-5.71-35.59-12.36-46-19.42-10.71-7.24-14.37-13.73-14.37-18.79s3.66-11.55 14.37-18.79c10.45-7.06 26.07-13.71 46-19.41C193.14 256.13 248.61 249 310.2 249s117.06 7.14 156.9 18.53c20 5.7 35.58 12.35 46 19.41 10.75 7.23 14.4 13.72 14.4 18.78Z"
      style={{
        fill: "#f2c94c",
        stroke: "#f5980c",
        strokeWidth: 15,
      }}
    />
    <path
      style={{
        fill: "none",
        stroke: "#f5980c",
        strokeWidth: 9,
      }}
      d="M27.5 226.81v33.03M467.93 226.81v33.03"
    />
    <ellipse
      cx={247.8}
      cy={259.84}
      rx={224.8}
      ry={64.23}
      style={{
        fill: "#f5980c",
      }}
    />
    <path
      d="M465.11 225c0 5.06-3.66 11.54-14.37 18.78-10.45 7.06-26.07 13.71-46 19.42-39.84 11.38-95.31 18.52-156.9 18.52s-117.06-7.14-156.9-18.52c-20-5.71-35.58-12.36-46-19.42C34.15 236.52 30.5 230 30.5 225s3.65-11.55 14.36-18.79c10.46-7.06 26.07-13.71 46-19.42 39.84-11.38 95.32-18.53 156.9-18.53s117.06 7.15 156.9 18.53c20 5.71 35.59 12.36 46 19.42 10.79 7.22 14.45 13.7 14.45 18.79Z"
      style={{
        fill: "#f2c94c",
        stroke: "#f5980c",
        strokeWidth: 15,
      }}
    />
    <path
      style={{
        fill: "none",
        stroke: "#f5980c",
        strokeWidth: 9,
      }}
      d="M89.89 146.06v33.04M530.32 146.06v33.04"
    />
    <ellipse
      cx={310.2}
      cy={179.1}
      rx={224.8}
      ry={64.23}
      style={{
        fill: "#f5980c",
      }}
    />
    <path
      d="M527.5 144.23c0 5.06-3.65 11.55-14.36 18.78-10.46 7.07-26.07 13.72-46 19.42C427.26 193.82 371.78 201 310.2 201s-117.06-7.14-156.9-18.53c-20-5.7-35.59-12.35-46-19.42-10.71-7.23-14.37-13.72-14.37-18.78s3.66-11.55 14.37-18.79c10.45-7.06 26.07-13.71 46-19.42 39.84-11.42 95.31-18.56 156.9-18.56s117.06 7.14 156.9 18.5c20 5.71 35.58 12.36 46 19.42 10.75 7.26 14.4 13.75 14.4 18.81Z"
      style={{
        fill: "#f2c94c",
        stroke: "#f5980c",
        strokeWidth: 15,
      }}
    />
  </svg>
);

export default Stakepile;
